var _polygon;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileChevron(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8,
    height: 5,
    viewBox: "0 0 8 5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "193 20.223 193.339 19.933 197 16.796 196.322 16 193 18.846 189.678 16 189 16.796 192.661 19.933",
    transform: "translate(-189 -16)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileChevron);
export default __webpack_public_path__ + "static/media/profile-chevron.b4dad20eb9f73256ae06659dd1aebfb4.svg";
export { ForwardRef as ReactComponent };